import utilityOne from "@assets/KPMG/investmentHub/utility/utility-1.jpg";
import utilityTwo from "@assets/KPMG/investmentHub/utility/utility-2.png";
import utilityThree from "@assets/KPMG/investmentHub/utility/utility-3.png";
import utilityFour from "@assets/KPMG/investmentHub/utility/utility-4.png";
import utilityFive from "@assets/KPMG/investmentHub/utility/utility-5.jpg";
import utilitySix from "@assets/KPMG/investmentHub/utility/utility-6.png";
import EnergyTwo from "@assets/KPMG/investmentHub/energy/energy-2.png";
import EnergyThree from "@assets/KPMG/investmentHub/energy/energy-3.png";
import EnergyFour from "@assets/KPMG/investmentHub/energy/energy-4.png";
import EnergyFive from "@assets/KPMG/investmentHub/energy/energy-5.png";
import EnergySeven from "@assets/KPMG/investmentHub/energy/energy-7.png";
import EnergyEight from "@assets/KPMG/investmentHub/energy/energy-8.png";
import EnergyNine from "@assets/KPMG/investmentHub//energy/energy-9.png";
import EnergyTen from "@assets/KPMG/investmentHub/energy/energy-10.png";
import EnergyEleven from "@assets/KPMG/investmentHub/energy/energy-11.png";
import EnergyOneTwo from "@assets/KPMG/investmentHub/energy/energy-12.png";
import BuildOne from "@assets/KPMG/investmentHub/builtEnvironment/build-1.png";
import BuildTwo from "@assets/KPMG/investmentHub/builtEnvironment/build-2.png";
import BuildThree from "@assets/KPMG/investmentHub/builtEnvironment/build-3.png";
import BuildFour from "@assets/KPMG/investmentHub/builtEnvironment/build-4.png";
import BuildFive from "@assets/KPMG/investmentHub/builtEnvironment/build-5.png";
import BuildSix from "@assets/KPMG/investmentHub/builtEnvironment/build-6.png";
import BuildSeven from "@assets/KPMG/investmentHub/builtEnvironment/build-7.png";
import BuildEight from "@assets/KPMG/investmentHub/builtEnvironment/build-8.png";
import BuildNine from "@assets/KPMG/investmentHub/builtEnvironment/build-9.png";
import BuildTen from "@assets/KPMG/investmentHub/builtEnvironment/build-10.png";
import BuildEleven from "@assets/KPMG/investmentHub/builtEnvironment/build-11.png";
import ConnectedBuilding from "@assets/KPMG/investmentHub/builtEnvironment/ConnectedBuilding.jpg";
import DevelopmentWaste from "@assets/KPMG/investmentHub/energy/DevelopmentWaste.jpg";
import GreaterCirebonMetropolitanArea from "@assets/KPMG/investmentHub/utility/GreaterCirebonMetropolitanArea.jpg";
import JointDevelopmentofHydropower from "@assets/KPMG/investmentHub/energy/JointDevelopmentofHydropower.jpg";
import LabuanBajoAirport from "@assets/KPMG/investmentHub/builtEnvironment/LabuanBajoAirport.png";
import LegokNangkaRegionalWasteProcessing from "@assets/KPMG/investmentHub/utility/LegokNangkaRegionalWasteProcessing.jpg";
import MRT11Project from "@assets/KPMG/investmentHub/builtEnvironment/MRT11Project.jpg";
import NewDelhiRailwayStationRedevelopment from "@assets/KPMG/investmentHub/builtEnvironment/NewDelhiRailwayStationRedevelopment.jpg";
import NewBoholInternationalAirportProject from "@assets/KPMG/investmentHub/builtEnvironment/NewBoholInternationalAirportProject.jpg";
import OneRafflesPlaceSmartTechAdoption from "@assets/KPMG/investmentHub/builtEnvironment/OneRafflesPlaceSmartTechAdoption.jpg";
import PhnomPenhCitySolidWasteCollection from "@assets/KPMG/investmentHub/utility/PhnomPenhCitySolidWasteCollection.jpg";
import PiyunganWasteTreatment from "@assets/KPMG/investmentHub/utility/PiyunganWasteTreatment.jpg";
import SemarangWastetoEnergyProject from "@assets/KPMG/investmentHub/utility/SemarangWastetoEnergyProject.jpg";
import SidrapWindFarm from "@assets/KPMG/investmentHub/energy/SidrapWindFarm.jpg";
import SolarPowerProject from "@assets/KPMG/investmentHub/energy/SolarPowerProject.jpg";
import ThailandAirportsExpansion from "@assets/KPMG/investmentHub/builtEnvironment/ThailandAirportsExpansion.jpg";
import TheBantenWindFarmPowerDevelopment from "@assets/KPMG/investmentHub/energy/TheBantenWindFarmPowerDevelopment.jpg";
import VietnamWaterSupplyInfrastructure from "@assets/KPMG/investmentHub/utility/VietnamWaterSupplyInfrastructure.jpg";
import ClarkSolarFarmSwt from "@assets/KPMG/investmentHub/energy/ClarkSolarFarmSwt.jpg";
import BandungMetropolitanUrbanRailway from "@assets/KPMG/investmentHub/builtEnvironment/BandungMetropolitanUrbanRailway.jpg";
import BangkokWastewaterProject from "@assets/KPMG/investmentHub/energy/BangkokWastewaterProject.jpg";
import BisligCityBulkWaterSupplyandSeptage from "@assets/KPMG/investmentHub/utility/BisligCityBulkWaterSupplyandSeptage.jpg";
import BuildingRetrofittinginBugis from "@assets/KPMG/investmentHub/utility/BuildingRetrofittinginBugis.jpg";
import ChangiEastTerminal from "@assets/KPMG/investmentHub/builtEnvironment/ChangiEastTerminal.jpg";

export const InvestmentHubData = [
  {
    key: "1",
    title: "Ir. H. Djuanda Water Supply (Jatiluhur II)",
    Location: "Indonesia",
    categories: [
      {
        name: "Utility",
        subcategories: ["Water Supply"],
      },
    ],
    description:
      "H Djuanda PPP Project is a creative effort of prospective proponents to contribute to achieve the target of Indonesia's piped drinking water supply. As the nation's capital and economic center with a large population, DKI Jakarta is required to continue to develop to meet the needs of its people. Djuanda development plan to provide drinking water for the daily needs of the community is one of the supporting developments as mandated in the DKI Jakarta Regional Mid-Term Development Plan (RPJMD). With the implementation of SPAM Ir. H Djuanda Project, it is hoped that it will meet the supply of drinking water for the people in DKI Jakarta.",
    InvestableRating: "80",
    EstimatedProjectCost: "USD 1,180 Million",
    TechInvolved: "AI and IoT",
    ProjectStage: "Planning",
    ESGRating: "4",
    image: utilityOne,
    map: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d253840.49131649232!2d106.66470446328029!3d-6.229720928728279!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2e69f3e945e34b9d%3A0x5371bf0fdad786a2!2sJakarta%2C%20Indonesia!5e0!3m2!1sen!2sin!4v1684888991041!5m2!1sen!2sin",
  },

  {
    key: "2",
    title: "Timor-Leste : Dili West Water Supply",
    Location: "Timor-Leste",
    categories: [
      {
        name: "Utility",
        subcategories: ["Water Supply"],
      },
    ],
    InvestableRating: "80",
    EstimatedProjectCost: "USD 1,180 Million",
    TechInvolved: "IoT",
    ProjectStage: "Planning",
    ESGRating: "4",
    image: utilityTwo,
  },

  {
    key: "3",
    title: "Vietnam’s water supply infrastructure",
    Location: "Vietnam",
    categories: [
      {
        name: "Utility",
        subcategories: ["Water Supply"],
      },
    ],
    EstimatedProjectCost: "USD 120 Million",
    InvestableRating: "70",
    TechInvolved: "AI",
    ProjectStage: "Planning",
    ESGRating: "4",
    image: VietnamWaterSupplyInfrastructure,
  },
  {
    key: "4",
    title: "water supply infrastructure",
    Location: "Vietnam",
    categories: [
      {
        name: "Utility",
        subcategories: ["Water Supply"],
      },
    ],
    EstimatedProjectCost: "USD 1,180 Million",
    InvestableRating: "80",
    TechInvolved: "AI and IoT",
    ProjectStage: "Planning",
    ESGRating: "4",
    image: utilityThree,
  },
  {
    key: "5",
    title: "water supply system",
    Location: "Vietnam",
    categories: [
      {
        name: "Utility",
        subcategories: ["Water Supply"],
      },
    ],
    EstimatedProjectCost: "USD 1,180 Million",
    InvestableRating: "80",
    TechInvolved: "AI and IoT",
    ProjectStage: "Planning",
    ESGRating: "4",
    image: utilityThree,
  },
  {
    key: "6",
    title: "water supply distribution network",
    Location: "Vietnam",
    categories: [
      {
        name: "Utility",
        subcategories: ["Water Supply"],
      },
    ],
    EstimatedProjectCost: "USD 1,180 Million",
    InvestableRating: "80",
    TechInvolved: "AI and IoT",
    ProjectStage: "Planning",
    ESGRating: "4",
    image: utilityFour,
  },

  {
    key: "7",
    title: "Binh Duong Water Treatment Expansion Project",
    Location: "Vietnam",
    categories: [
      {
        name: "Utility",
        subcategories: ["Water Treatment"],
      },
    ],
    EstimatedProjectCost: "USD 46 Million",
    InvestableRating: "70",
    TechInvolved: "AI and IoT",
    ProjectStage: "Planning",
    ESGRating: "4.5",
    image: utilityFive,
  },

  {
    key: "8",
    title: "ASEAN Integrated River Management Project",
    Location: "Philippine",
    categories: [
      {
        name: "Utility",
        subcategories: ["Water Treatment"],
      },
    ],
    EstimatedProjectCost: "USD 130 Million",
    InvestableRating: "75",
    TechInvolved: "Data Analytics",
    ProjectStage: "Planning",
    ESGRating: "4",
    image: utilitySix,
  },

  {
    key: "9",
    title: "Water Management",
    Location: "Manila",
    categories: [
      {
        name: "Utility",
        subcategories: ["Water Treatment"],
      },
    ],
    EstimatedProjectCost: "USD 46 Million",
    InvestableRating: "70",
    TechInvolved: "AI and IoT",
    ProjectStage: "Planning",
    ESGRating: "4",
    image: utilitySix,
  },
  {
    key: "10",
    title: "Water Treatment",
    Location: "Manila",
    categories: [
      {
        name: "Utility",
        subcategories: ["Water Treatment"],
      },
    ],
    EstimatedProjectCost: "USD 46 Million",
    InvestableRating: "70",
    TechInvolved: "AI and IoT",
    ProjectStage: "Planning",
    ESGRating: "4",
    image: utilitySix,
  },
  {
    key: "11",
    title: "Water Treatment Expansion",
    Location: "Manila",
    categories: [
      {
        name: "Utility",
        subcategories: ["Water Treatment"],
      },
    ],
    EstimatedProjectCost: "USD 46 Million",
    InvestableRating: "70",
    TechInvolved: "AI and IoT",
    ProjectStage: "Planning",
    ESGRating: "4",
    image: utilitySix,
  },
  {
    key: "12",
    title: "Water Treatment Expansion",
    Location: "Manila",
    categories: [
      {
        name: "Utility",
        subcategories: ["Water Treatment"],
      },
    ],
    EstimatedProjectCost: "USD 46 Million",
    InvestableRating: "70",
    TechInvolved: "AI and IoT",
    ProjectStage: "Planning",
    ESGRating: "4",
    image: utilitySix,
  },

  {
    key: "13",
    title: "Solar Power Project",
    Location: "Indonesia",
    categories: [
      {
        name: "Energy",
        subcategories: ["Solar"],
      },
    ],
    EstimatedProjectCost: "USD 59.35 Billion",
    InvestableRating: "90",
    TechInvolved: "AI, IoT, Predictive",
    ProjectStage: "Planning",
    ESGRating: "5",
    image: EnergyThree,
  },
  {
    key: "63",
    title: "25-MW Clark Solar Farm Swt",
    Location: "Philippine",
    categories: [
      {
        name: "Energy",
        subcategories: ["Solar"],
      },
    ],
    EstimatedProjectCost: "USD 18 Million",
    InvestableRating: "80",
    TechInvolved: "Data Analytics",
    ProjectStage: "Planning",
    ESGRating: "5",
    image: ClarkSolarFarmSwt,
  },
  {
    key: "15",
    title: "Solar Power Project",
    Location: "Indonesia",
    categories: [
      {
        name: "Energy",
        subcategories: ["Solar"],
      },
    ],
    EstimatedProjectCost: "USD 59.35 Billion",
    InvestableRating: "90",
    TechInvolved: "AI, IoT, Predictive",
    ProjectStage: "Planning",
    ESGRating: "5",
    image: EnergyThree,
  },
  {
    key: "16",
    title: "Solar Power Project",
    Location: "Indonesia",
    categories: [
      {
        name: "Energy",
        subcategories: ["Solar"],
      },
    ],
    EstimatedProjectCost: "USD 59.35 Billion",
    InvestableRating: "90",
    TechInvolved: "AI, IoT, Predictive",
    ProjectStage: "Planning",
    ESGRating: "5",
    image: EnergyThree,
  },
  {
    key: "17",
    title: "Solar Power Project",
    Location: "Indonesia",
    categories: [
      {
        name: "Energy",
        subcategories: ["Solar"],
      },
    ],
    EstimatedProjectCost: "USD 59.35 Billion",
    InvestableRating: "90",
    TechInvolved: "AI, IoT, Predictive",
    ProjectStage: "Planning",
    ESGRating: "5",
    image: EnergyThree,
  },
  {
    key: "18",
    title: "Solar Power Project",
    Location: "Indonesia",
    categories: [
      {
        name: "Energy",
        subcategories: ["Solar"],
      },
    ],
    EstimatedProjectCost: "USD 59.35 Billion",
    InvestableRating: "90",
    TechInvolved: "AI, IoT, Predictive",
    ProjectStage: "Planning",
    ESGRating: "5",
    image: EnergyThree,
  },

  {
    key: "19",
    title: "Sidrap Wind Farm",
    Location: "Indonesia",
    categories: [
      {
        name: "Energy",
        subcategories: ["Wind"],
      },
    ],
    EstimatedProjectCost: "USD 200 Million",
    InvestableRating: "90",
    TechInvolved: "Data Analytics",
    ProjectStage: "Planning",
    ESGRating: "4",
    image: SidrapWindFarm,
  },

  {
    key: "20",
    title: "The Banten Wind Farm Power Development project",
    Location: "Indonesia",
    categories: [
      {
        name: "Energy",
        subcategories: ["Wind"],
      },
    ],
    EstimatedProjectCost: "USD 1,180 Million",
    InvestableRating: "90",
    TechInvolved: "AI and IoT",
    ProjectStage: "Planning",
    ESGRating: "5",
    image: TheBantenWindFarmPowerDevelopment,
  },

  {
    key: "21",
    title: "Wind Power Project",
    Location: "Vietnem",
    categories: [
      {
        name: "Energy",
        subcategories: ["Wind"],
      },
    ],
    EstimatedProjectCost: "USD 1,180 Million",
    InvestableRating: "90",
    TechInvolved: "AI and IoT",
    ProjectStage: "Planning",
    ESGRating: "5",
    image: EnergyFour,
  },
  {
    key: "22",
    title: "Eastern Indonesia Renewable Energy Project",
    Location: "Indonesia",
    categories: [
      {
        name: "Energy",
        subcategories: ["Wind"],
      },
    ],
    EstimatedProjectCost: "USD 1,180 Million",
    InvestableRating: "90",
    TechInvolved: "AI and IoT",
    ProjectStage: "Phase-1",
    ESGRating: "5",
    image: EnergySeven,
  },
  {
    key: "23",
    title: "Wind Power Project",
    Location: "Vietnem",
    categories: [
      {
        name: "Energy",
        subcategories: ["Wind"],
      },
    ],
    EstimatedProjectCost: "USD 1,180 Million",
    InvestableRating: "90",
    TechInvolved: "AI and IoT",
    ProjectStage: "Planning",
    ESGRating: "5",
    image: EnergyFour,
  },
  {
    key: "24",
    title: "Wind Power Project",
    Location: "Vietnem",
    categories: [
      {
        name: "Energy",
        subcategories: ["Wind"],
      },
    ],
    EstimatedProjectCost: "USD 1,180 Million",
    InvestableRating: "90",
    TechInvolved: "AI and IoT",
    ProjectStage: "Planning",
    ESGRating: "5",
    image: EnergyFour,
  },

  {
    key: "25",
    title: "Bangkok Wastewater Project, Stage IV",
    Location: "Bangkok, Thailand",
    categories: [
      {
        name: "Energy",
        subcategories: ["Waste to Energy"],
      },
    ],
    EstimatedProjectCost: "USD 98 Million",
    InvestableRating: "55",
    TechInvolved: "IoT and Analytics",
    ProjectStage: "Planning",
    ESGRating: "5",
    image: BangkokWastewaterProject,
  },

  {
    key: "26",
    title: "Development Waste to Energy Facility",
    Location: "South Tangerang, Indonesia",
    categories: [
      {
        name: "Energy",
        subcategories: ["Waste to Energy"],
      },
    ],
    EstimatedProjectCost: "USD 122.9 Million",
    InvestableRating: "85",
    TechInvolved: "IoT",
    ProjectStage: "Planning",
    ESGRating: "5",
    image: DevelopmentWaste,
  },

  {
    key: "27",
    title: "Semarang Waste to Energy Project",
    Location: "Indonesia",
    categories: [
      {
        name: "Energy",
        subcategories: ["Waste to Energy"],
      },
    ],
    EstimatedProjectCost: "USD 1,180 Million",
    InvestableRating: "55",
    TechInvolved: "AI and IoT",
    ProjectStage: "Planning",
    ESGRating: "5",
    image: EnergyTen,
  },

  {
    key: "28",
    title: "Bantar Gebang Refuse-Derived Fuel Plant in Jakarta",
    Location: "Indonesia",
    categories: [
      {
        name: "Energy",
        subcategories: ["Waste to Energy"],
      },
    ],
    EstimatedProjectCost: "USD 1,180 Million",
    InvestableRating: "55",
    TechInvolved: "AI and IoT",
    ProjectStage: "Planning",
    ESGRating: "5",
    image: EnergyEleven,
  },

  {
    key: "29",
    title: "Banyumas Minihydro Power Plant",
    Location: "Indonesia",
    categories: [
      {
        name: "Energy",
        subcategories: ["Waste to Energy"],
      },
    ],
    EstimatedProjectCost: "USD 1,180 Million",
    InvestableRating: "55",
    TechInvolved: "AI and IoT",
    ProjectStage: "Planning",
    ESGRating: "5",
    image: EnergyOneTwo,
  },

  {
    key: "30",
    title: "Power Plant",
    categories: [
      {
        name: "Energy",
        subcategories: ["Waste to Energy"],
      },
    ],
    Location: "Indonesia",
    EstimatedProjectCost: "USD 1,180 Million",
    InvestableRating: "55",
    TechInvolved: "AI and IoT",
    ProjectStage: "Planning",
    ESGRating: "5",
    image: EnergyEight,
  },

  {
    key: "31",
    title: "Connected Building Enablement in Capita Spring",
    InvestableRating: "90",
    categories: [
      {
        name: "Built Environment",
        subcategories: ["Smart Building"],
      },
    ],
    ESGRating: "5",
    Location: "Singapore",
    image: ConnectedBuilding,
  },
  {
    key: "32",
    title: "One Raffles Place Smart Tech Adoption",
    InvestableRating: "90",
    categories: [
      {
        name: "Built Environment",
        subcategories: ["Smart Building"],
      },
    ],
    EstimatedProjectCost: "USD 5 Million",
    ESGRating: "5",
    TechInvolved: "IoT",
    Location: "Singapore",
    image: OneRafflesPlaceSmartTechAdoption,
  },
  {
    key: "33",
    title: "Building Retrofitting in Bugis",
    categories: [
      {
        name: "Built Environment",
        subcategories: ["Smart Building"],
      },
    ],
    EstimatedProjectCost: "USD 30 Million",
    InvestableRating: "30",
    ESGRating: "4",
    TechInvolved: "IoT",
    Location: "Singapore",
    image: BuildingRetrofittinginBugis,
  },
  {
    key: "34",
    title: "Smart Building Development",
    categories: [
      {
        name: "Built Environment",
        subcategories: ["Smart Building"],
      },
    ],
    InvestableRating: "90",
    ESGRating: "5",
    Location: "Indonesia",
    image: EnergyThree,
  },
  {
    key: "35",
    title: "Smart Building Development",
    categories: [
      {
        name: "Built Environment",
        subcategories: ["Smart Building"],
      },
    ],
    InvestableRating: "90",
    ESGRating: "5",
    Location: "Indonesia",
    image: EnergyThree,
  },
  {
    key: "36",
    title: "Smart Building Development",
    categories: [
      {
        name: "Built Environment",
        subcategories: ["Smart Building"],
      },
    ],
    InvestableRating: "90",
    ESGRating: "5",
    Location: "Indonesia",
    image: EnergyThree,
  },
  {
    key: "37",
    title: "New Bohol International Airport Project",
    Location: "Philippine",
    categories: [
      {
        name: "Built Environment",
        subcategories: ["Airports"],
      },
    ],
    EstimatedProjectCost: "USD 80 Million",
    InvestableRating: "85",
    TechInvolved: "Data-Driven Dashboard",
    ProjectStage: "Planning",
    ESGRating: "5",
    image: NewBoholInternationalAirportProject,
  },

  {
    key: "38",
    title: "Labuan Bajo Airport",
    Location: "Indonesia",
    categories: [
      {
        name: "Built Environment",
        subcategories: ["Airports"],
      },
    ],
    EstimatedProjectCost: "USD 88.3 Million",
    InvestableRating: "85",
    TechInvolved: "AI-ML",
    ProjectStage: "Procurement",
    ESGRating: "5",
    image: LabuanBajoAirport,
  },

  {
    key: "39",
    title: "Changi East Terminal and Supporting Infrastructure",
    Location: "Singapore",
    categories: [
      {
        name: "Built Environment",
        subcategories: ["Airports"],
      },
    ],
    EstimatedProjectCost: "USD 45 Million",
    InvestableRating: "90",
    TechInvolved: "Automation",
    ProjectStage: "Procurement",
    ESGRating: "3",
    image: ChangiEastTerminal,
  },

  {
    key: "40",
    title:
      "Thailand is accelerating expansion plans at three Bangkok-area airports",
    Location: "Thailand",
    categories: [
      {
        name: "Built Environment",
        subcategories: ["Airports"],
      },
    ],
    EstimatedProjectCost: "USD 1,180 Million",
    InvestableRating: "100",
    TechInvolved: "AI and IoT",
    ProjectStage: "Planning",
    ESGRating: "5",
    image: BuildFour,
  },

  {
    key: "41",
    title: "Airport Expansion",
    Location: "Thailand",
    categories: [
      {
        name: "Built Environment",
        subcategories: ["Airports"],
      },
    ],
    EstimatedProjectCost: "USD 1,180 Million",
    InvestableRating: "100",
    TechInvolved: "AI and IoT",
    ProjectStage: "Planning",
    ESGRating: "5",
    image: BuildTwo,
  },

  {
    key: "43",
    title: "MRT-11 Project",
    Location: "Quezon City, Philippine",
    categories: [
      {
        name: "Built Environment",
        subcategories: ["Railways"],
      },
    ],
    EstimatedProjectCost: "USD 30 Billion",
    InvestableRating: "80",
    TechInvolved: "IoT",
    ProjectStage: "Procurement",
    ESGRating: "4",
    image: MRT11Project,
  },
  {
    key: "44",
    title: "Kaliwa Dam Project",
    Location: "Philippine",
    categories: [
      {
        name: "Built Environment",
        subcategories: ["Railways"],
      },
    ],
    EstimatedProjectCost: "USD 240 Million",
    InvestableRating: "80",
    TechInvolved: "Sensors and Analytics",
    ProjectStage: "Development",
    ESGRating: "4",
    image: BuildSix,
  },
  {
    key: "45",
    title: "Rail Expansion Singapore",
    Location: "Philippine",
    categories: [
      {
        name: "Built Environment",
        subcategories: ["Railways"],
      },
    ],
    EstimatedProjectCost: "USD 240 Billion",
    InvestableRating: "80",
    TechInvolved: "Sensors and Analytics",
    ProjectStage: "Development",
    ESGRating: "4",
    image: BuildSeven,
  },
  {
    key: "46",
    title: "Kuala Lumpur–Singapore high-speed rail",
    Location: "Malaysia & Singapore",
    categories: [
      {
        name: "Built Environment",
        subcategories: ["Railways"],
      },
    ],
    EstimatedProjectCost: "USD 1,180 Million",
    InvestableRating: "90",
    TechInvolved: "AI and IoT",
    ProjectStage: "Development",
    ESGRating: "4",
    image: BuildEight,
  },
  {
    key: "47",
    title: "South Commuter Railway Project",
    Location: "Philippine",
    categories: [
      {
        name: "Built Environment",
        subcategories: ["Railways"],
      },
    ],
    EstimatedProjectCost: "USD 1,180 Million",
    InvestableRating: "90",
    TechInvolved: "AI and IoT",
    ProjectStage: "Development",
    ESGRating: "4",
    image: BuildNine,
  },
  {
    key: "48",
    title: "Railway Project",
    Location: "Philippine",
    categories: [
      {
        name: "Built Environment",
        subcategories: ["Railways"],
      },
    ],
    EstimatedProjectCost: "USD 1,180 Million",
    InvestableRating: "90",
    TechInvolved: "AI and IoT",
    ProjectStage: "Development",
    ESGRating: "4",
    image: BuildFive,
  },
  {
    key: "49",
    title: "Patimban Access Toll Road",
    Location: "West Java, Indonesia",
    categories: [
      {
        name: "Built Environment",
        subcategories: ["Highways"],
      },
    ],
    EstimatedProjectCost: "USD 590.94 Million",
    InvestableRating: "85",
    TechInvolved: "Automatic Gate Payment",
    ProjectStage: "Planning",
    ESGRating: "3",
    image: BuildTen,
  },
  {
    key: "50",
    title: "Highways construction",
    Location: "West Java, Indonesia",
    categories: [
      {
        name: "Built Environment",
        subcategories: ["Highways"],
      },
    ],
    EstimatedProjectCost: "USD 1,180 Million",
    InvestableRating: "85",
    TechInvolved: "AI and IoT",
    ProjectStage: "Planning",
    ESGRating: "3",
    image: BuildEleven,
  },
  {
    key: "51",
    title: "Highways construction",
    Location: "West Java, Indonesia",
    categories: [
      {
        name: "Built Environment",
        subcategories: ["Highways"],
      },
    ],
    EstimatedProjectCost: "USD 1,180 Million",
    InvestableRating: "85",
    TechInvolved: "AI and IoT",
    ProjectStage: "Planning",
    ESGRating: "3",
    image: BuildEleven,
  },
  {
    key: "52",
    title: "Highways construction",
    Location: "West Java, Indonesia",
    categories: [
      {
        name: "Built Environment",
        subcategories: ["Highways"],
      },
    ],
    EstimatedProjectCost: "USD 1,180 Million",
    InvestableRating: "85",
    TechInvolved: "AI and IoT",
    ProjectStage: "Planning",
    ESGRating: "3",
    image: BuildEleven,
  },
  {
    key: "53",
    title: "Highways construction",
    Location: "West Java, Indonesia",
    categories: [
      {
        name: "Built Environment",
        subcategories: ["Highways"],
      },
    ],
    EstimatedProjectCost: "USD 1,180 Million",
    InvestableRating: "85",
    TechInvolved: "AI and IoT",
    ProjectStage: "Planning",
    ESGRating: "3",
    image: BuildEleven,
  },
  {
    key: "54",
    title: "Highways construction",
    Location: "West Java, Indonesia",
    categories: [
      {
        name: "Built Environment",
        subcategories: ["Highways"],
      },
    ],
    EstimatedProjectCost: "USD 1,180 Million",
    InvestableRating: "85",
    TechInvolved: "AI and IoT",
    ProjectStage: "Planning",
    ESGRating: "3",
    image: BuildEleven,
  },
  {
    key: "55",
    title: "Sinumbra Regional Water Supply System",
    Location: "Indonesia",
    categories: [
      {
        name: "Utility",
        subcategories: ["Water Supply"],
      },
    ],
    EstimatedProjectCost: "USD 51.25 Million",
    InvestableRating: "85",
    TechInvolved: "AI",
    ProjectStage: "Planning",
    ESGRating: "3",
    image: BuildEleven,
  },
  {
    key: "56",
    title:
      "Greater Cirebon Metropolitan Area (Jatigede) Regional Water Supply Project Phase I",
    Location: "Indonesia",
    categories: [
      {
        name: "Utility",
        subcategories: ["Water Treatment"],
      },
    ],
    EstimatedProjectCost: "USD 142 Million",
    InvestableRating: "60",
    TechInvolved: "Data Analytics",
    ProjectStage: "Final Business Case",
    ESGRating: "4",
    image: GreaterCirebonMetropolitanArea,
  },
  {
    key: "57",
    title: "Bislig City Bulk Water Supply and Septage Project",
    Location: "Philippine",
    categories: [
      {
        name: "Utility",
        subcategories: ["Water Supply"],
      },
    ],
    EstimatedProjectCost: "USD 5.8 Million",
    InvestableRating: "75",
    TechInvolved: "Data Analytics",
    ProjectStage: "Feasibility Study",
    ESGRating: "4.5",
    image: BisligCityBulkWaterSupplyandSeptage,
  },
  {
    key: "58",
    title: "Ormoc Ciry Water Supply System",
    Location: "Philippine",
    categories: [
      {
        name: "Utility",
        subcategories: ["Water Supply"],
      },
    ],
    EstimatedProjectCost: "USD 147 Million",
    InvestableRating: "70",
    TechInvolved: "IoT",
    ProjectStage: "Engineering & Procurement",
    ESGRating: "4",
    image: BuildEleven,
  },
  {
    key: "59",
    title: "Legok Nangka Regional Waste Processing and Final Processing Site",
    Location: "Indonesia",
    categories: [
      {
        name: "Utility",
        subcategories: ["Waste"],
      },
    ],
    EstimatedProjectCost: "USD 275 Million",
    InvestableRating: "80",
    TechInvolved: "Automation",
    ProjectStage: "Feasibility Study",
    ESGRating: "3",
    image: LegokNangkaRegionalWasteProcessing,
  },
  {
    key: "59",
    title: "Jatibarang Waste Management",
    Location: "Indonesia",
    categories: [
      {
        name: "Utility",
        subcategories: ["Waste"],
      },
    ],
    EstimatedProjectCost: "USD 224 Million",
    InvestableRating: "85",
    TechInvolved: "Automation",
    ProjectStage: "Feasibility Study",
    ESGRating: "3.5",
    image: BuildEleven,
  },
  {
    key: "60",
    title: "Phnom Penh City Solid Waste Collection & Transportation",
    Location: "Cambodia",
    categories: [
      {
        name: "Utility",
        subcategories: ["Waste"],
      },
    ],
    EstimatedProjectCost: "USD 46 Million",
    InvestableRating: "85",
    TechInvolved: "Automation",
    ProjectStage: "Feasibility Study",
    ESGRating: "4.8",
    image: PhnomPenhCitySolidWasteCollection,
  },
  {
    key: "61",
    title: "Piyungan Waste Treatment",
    desription:
      "The capacity of waste landfill (TPA) has been exceeded while there is an increase in the volume of waste that enters Piyungan Landfill, so appropriate technology and professional operation management are necessary. Piyungan Landfill receives around 650 - 700 tonnes per day of waste from Yogyakarta City, Sleman Regency, and Bantul Regency",
    Location: "Indonesia",
    categories: [
      {
        name: "Utility",
        subcategories: ["Waste"],
      },
    ],
    EstimatedProjectCost: "USD 177 Million",
    InvestableRating: "95",
    TechInvolved: "Data Analytics",
    ProjectStage: "Business Case",
    ESGRating: "5",
    map: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d30329.04960580405!2d110.43079441533787!3d-7.8693109634018965!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2e7a51530252dca9%3A0xea0d715b1f6b5fad!2sPiyungan%20Landfill!5e0!3m2!1sen!2sin!4v1684897273947!5m2!1sen!2sin",
    image: PiyunganWasteTreatment,
  },
  {
    key: "62",
    title: "Solar Power Project",
    Location: "Indonesia",
    categories: [
      {
        name: "Energy",
        subcategories: ["Solar"],
      },
    ],
    EstimatedProjectCost: "USD 5935 Million",
    InvestableRating: "90",
    TechInvolved: "AI & IoT",
    ProjectStage: "Planning",
    ESGRating: "5",
    image: SolarPowerProject,
  },
  {
    key: "63",
    title: "The Banten Wind Farm Power Development Project",
    Location: "Indonesia",
    categories: [
      {
        name: "Energy",
        subcategories: ["Wind"],
      },
    ],
    EstimatedProjectCost: "USD 350 Million",
    InvestableRating: "85",
    TechInvolved: "Data Analytics",
    ProjectStage: "Planning",
    ESGRating: "3.5",
    image: BuildEleven,
  },
  {
    key: "64",
    title: "Joint Development of Hydropower Projects in Nepal (1185 MW)",
    Location: "Nepal",
    categories: [
      {
        name: "Energy",
        subcategories: ["Hydropower"],
      },
    ],
    EstimatedProjectCost: "USD 1700 Million",
    InvestableRating: "90",
    TechInvolved: "IoT",
    ProjectStage: "Planning",
    ESGRating: "4",
    image: JointDevelopmentofHydropower,
  },
  {
    key: "65",
    title: "Bangkok Wastewater Project",
    Location: "Thailand",
    categories: [
      {
        name: "Energy",
        subcategories: ["Waste to Energy"],
      },
    ],
    EstimatedProjectCost: "USD 1700 Million",
    InvestableRating: "75",
    TechInvolved: "IoT & Analytics",
    ProjectStage: "Planning",
    ESGRating: "4",
    image: BuildEleven,
  },
  {
    key: "66",
    title: "Development Waste to Energy Facility",
    Location: "Indonesia",
    categories: [
      {
        name: "Energy",
        subcategories: ["Waste to Energy"],
      },
    ],
    EstimatedProjectCost: "USD 122.9 Million",
    InvestableRating: "70",
    TechInvolved: "IoT",
    ProjectStage: "Planning",
    ESGRating: "4",
    image: DevelopmentWaste,
  },
  {
    key: "67",
    title: "Semarang Waste to Energy Project",
    Location: "Indonesia",
    categories: [
      {
        name: "Energy",
        subcategories: ["Waste to Energy"],
      },
    ],
    EstimatedProjectCost: "USD 130 Million",
    InvestableRating: "80",
    TechInvolved: "Analytics",
    ProjectStage: "Feasibility Study",
    ESGRating: "5",
    image: SemarangWastetoEnergyProject,
  },
  {
    key: "68",
    title: "Connected Building Enablement in Capita Spring",
    Location: "Singapore",
    categories: [
      {
        name: "Built Environment",
        subcategories: ["Smart Building"],
      },
    ],
    EstimatedProjectCost: "USD 10 Million",
    InvestableRating: "85",
    TechInvolved: "Analytics",
    ProjectStage: "Feasibility Study",
    ESGRating: "3.5",
    image: ConnectedBuilding,
  },
  {
    key: "69",
    title: "Connected Building Enablement in Capita Spring",
    Location: "Singapore",
    categories: [
      {
        name: "Built Environment",
        subcategories: ["Smart Building"],
      },
    ],
    EstimatedProjectCost: "USD 10 Million",
    InvestableRating: "85",
    TechInvolved: "Analytics",
    ProjectStage: "Feasibility Study",
    ESGRating: "3.5",
    image: ConnectedBuilding,
  },
  {
    key: "70",
    title: "Thailand Airports Expansion",
    Location: "Thailand",
    categories: [
      {
        name: "Built Environment",
        subcategories: ["Airports"],
      },
    ],
    EstimatedProjectCost: "USD 20 Million",
    InvestableRating: "75",
    TechInvolved: "Data-Driven Dashboard",
    ProjectStage: "Procurement",
    ESGRating: "3.5",
    image: ThailandAirportsExpansion,
  },
  {
    key: "71",
    title: "Bandung Metropolitan Urban Railway Project",
    desription:
      "In 2019 around 12.3 million trips per day were made in Greater Bandung, only 12% of them were made by public transport.It is estimated that about one third(36%) of the road network will be saturated by 2023 and this will increase to about two thirds(70.5 %) by 2030. The proposed mass transit project will therefore make better use of limited urban space by moving people faster and more reliably.",
    Location: "Indonesia",
    categories: [
      {
        name: "Built Environment",
        subcategories: ["Railways"],
      },
    ],
    EstimatedProjectCost: "USD 810.38 Million",
    InvestableRating: "75",
    TechInvolved: "AI & ML",
    ProjectStage: "Procurement",
    ESGRating: "3.5",
    map: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d126748.56400419603!2d107.5607554697324!3d-6.903442379407542!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2e68e6398252477f%3A0x146a1f93d3e815b2!2sBandung%2C%20Bandung%20City%2C%20West%20Java%2C%20Indonesia!5e0!3m2!1sen!2sin!4v1684897403846!5m2!1sen!2sin",
    image: BandungMetropolitanUrbanRailway,
  },
  {
    key: "72",
    title: "New Delhi Railway Station Redevelopmentt",
    Location: "India",
    categories: [
      {
        name: "Built Environment",
        subcategories: ["Railways"],
      },
    ],
    EstimatedProjectCost: "USD 700 Million",
    InvestableRating: "70",
    TechInvolved: "IoT",
    ProjectStage: "Detailed Planning",
    ESGRating: "4.5",
    image: NewDelhiRailwayStationRedevelopment,
  },
];
